export function detectRuntime(): { runtime: string; runtimeVersion: string } {
  const g = globalThis as any

  if (g.Bun) {
    return {
      runtime: 'bun',
      runtimeVersion: g.Bun.version,
    }
  }

  if (g.Deno) {
    return {
      runtime: 'deno',
      runtimeVersion: g.Deno.version.deno,
    }
  }

  if (typeof process !== 'undefined' && process.versions?.node) {
    return {
      runtime: 'node',
      runtimeVersion: process.versions.node,
    }
  }

  if (typeof navigator !== 'undefined') {
    return {
      runtime: 'browser',
      runtimeVersion: navigator.userAgent,
    }
  }

  return {
    runtime: 'unknown',
    runtimeVersion: 'unknown',
  }
}
